





















































import { defineComponent, PropType } from '@nuxtjs/composition-api';

import { Mark } from '../../../constants';
import { MarkNode } from '../../../types';
import SbLink from '../../marks/Link.vue';

interface IHeadingContent {
  text: string;
  type: string;
  marks: Array<IMarks>;
}

interface IMarks {
  type: string;
}

export default defineComponent({
  name: 'SbHeading',
  components: {
    SbLink,
  },
  props: {
    content: {
      type: Array as PropType<IHeadingContent[]>,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
  },
  methods: {
    headingClass(index: number): Array<string> {
      let headingClass = [''];
      const marks = this.content[index].marks;
      if (marks) {
        marks.forEach((mark) => {
          switch (mark.type) {
            case Mark.STRIKE:
              headingClass.push('sb-heading--strike');
              break;
            case Mark.UNDERLINE:
              headingClass.push('sb-heading--underline');
              break;
            case Mark.ITALIC:
              headingClass.push('sb-heading--italic');
              break;
          }
        });
      }

      return headingClass;
    },

    isLink(marks: MarkNode[]): boolean {
      return marks && marks.findIndex((mark) => mark.type === Mark.LINK) > -1;
    },

    getAttrs(marks: MarkNode[]) {
      const linkMark = marks.find((mark) => mark.type === Mark.LINK);
      if (linkMark) return linkMark.attrs;
      else return {};
    },
  },
});
